module.exports = __webpack_public_path__ + "media/icons/external-10af979e.svg";